import { Check } from "lucide-react";
import {ReactComponent as Confittie } from "../../assets/animations/confittie.svg"

const SubmissionSuccess = ({ companyName }) => {
    return (
        <div className="px-8 py-10 text-center max-w-3xl">
            {/* ICON */}
            <div className="relative flex justify-center mb-6">
                <div className="flex items-center justify-center">
                    <Confittie/>
                    {}
                </div>
            </div>

            {/* TITLE */}
            <h2 className="text-[32px] font-bold text-[#4A4344] mb-b">
                Reference submitted
            </h2>

            {/* DESCRIPTION */}
            <p className="text-[16px] text-[#686262] leading-relaxed max-w-[514px]">
                Thank you for submitting a payment reference for{" "}
                <span className="font-medium text-[#4A4344]">
                    {companyName}
                </span>
                . Your input helps businesses make faster credit decisions.
            </p>
        </div>
    );
};

export default SubmissionSuccess;
